import { useFormikContext } from 'formik';

import { Button } from '@hivebrite/design-system/Button';

import { MODE } from '../constants';
import type { FormValues, ModeValues } from '../types';

export const Submit = ({ mode }: { mode: ModeValues }) => {
  const { isSubmitting, values } = useFormikContext<FormValues>();

  let children: string;

  if (isSubmitting) {
    children = s__('JobForm|Saving');
  } else if (values.draft) {
    if (mode === MODE.PO) {
      children = s__('JobForm|Submit');
    } else {
      children = s__('JobForm|Publish');
    }
  } else {
    children = s__('JobForm|Save');
  }

  return (
    <Button ml={6} type="submit" variant="primary">
      {children}
    </Button>
  );
};
